// Angular
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Services
import { AuthService } from '../../../auth';

// Libraries
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { takeUntil } from 'rxjs';
// Models
import { AppCleanup } from '../../../../shared/models';
import { PasswordChangeDto } from '../../../auth/models/password-change-dto.model';

// Validators
import { ConfirmPasswordValidator } from '../../../../shared/validators/confirm-password.validator';

// Helpers
import { FormHelper } from '../../../../shared/helpers';

@Component({
	selector: 'change-password-admin-dialog',
	templateUrl: './change-password-admin-dialog.component.html',
	styleUrls: ['./change-password-admin-dialog.component.scss'],
})
export class ChangePasswordAdminDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	componentTitle: string = 'Change password';
	form: FormGroup;
	showPassword: boolean = false;
	showConfirmPassword: boolean = false;

	constructor(
		public formBuilder: FormBuilder,
		private authService: AuthService,
		public dialogRef: MatDialogRef<ChangePasswordAdminDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		super();
	}

	ngOnInit() {
		this.initRegisterForm();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	initRegisterForm() {
		this.form = this.formBuilder.group(
			{
				password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])],
				confirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])],
			},
			{
				validator: ConfirmPasswordValidator.MatchPassword,
			}
		);

		setTimeout(() => {
			this.form.reset();
		}, 1000);
	}

	changePassword() {
		let passwordChange: PasswordChangeDto = {
			newPassword: this.form.controls.password.value,
			userNameOrEmail: this.data.username,
		};
		this.authService
			.changePasswordFromAdmin(passwordChange)
			.pipe(takeUntil(this.destroy))
			.subscribe(() => {
				this.dialogRef.close(true);
			});
	}

	controlHasError(controlName: string, validationType: string): boolean {
		return FormHelper.controlHasError(this.form, controlName, validationType);
	}
}
